/*
 * Module for the status pills used by the other tasks list
 */

define([
  "marionette",
  "messaging/messenger",
  "./reviewerOtherTasksListToggleView",
  "modules/tasks/tasksModel",
], function (Marionette, Messenger, ReviewerOtherTasksListToggleView, TaskModel) {
  "use strict";

  let ReviewerOtherTasksListToggleController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "reviewerOtherTasksListToggle";
      this.region = options.region;
    },
    show: function () {
      this.view = new ReviewerOtherTasksListToggleView.reviewerOtherTasksListToggleView();

      this.view.on(
        "show:not:started",
        function () {
          //save before switching
          Messenger.save(function (success) {
            if (success) {
              Messenger.vent.trigger("show:other:tasks:list", TaskModel.STATUS.NOT_STARTED);
            }
          }, this);
        },
        this,
      );

      this.view.on(
        "show:in:progress",
        function () {
          //save before switching
          Messenger.save(function (success) {
            if (success) {
              Messenger.vent.trigger("show:other:tasks:list", TaskModel.STATUS.IN_PROGRESS);
            }
          }, this);
        },
        this,
      );

      this.view.on(
        "show:rejected",
        function () {
          //save before switching
          Messenger.save(function (success) {
            if (success) {
              Messenger.vent.trigger("show:other:tasks:list", TaskModel.STATUS.FAILED);
            }
          }, this);
        },
        this,
      );

      this.showRegion(this.view);
    },
  });

  return ReviewerOtherTasksListToggleController;
});
